<template>
  <v-container id="docForm" class="max-width">
    <!-- first card -->
    <v-card>
      <v-toolbar dense flat color="secondary" dark>
        <v-toolbar-title>Create Debit Note</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/debit-notes" dark>
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" md="7">
                <span style="font-size: 16px; font-weight: bold">Bill Details</span>
                <v-autocomplete
              autocomplete="off"
              dense
              outlined
              v-model="record.SupplierId"
              :items="suppliers"
              label="Supplier"
              item-text="Name"
              item-value="id"
              :search-input.sync="searchSuppliers"
            >
              <!-- <template v-if="enableCreate" v-slot:no-data>
                <v-row align="center" justify="center">
                  <v-btn
                    :loading="searchingProduct"
                    class="ma-2"
                    color="accent"
                    dark
                    small
                    elevation="0"
                    @click="openCreate()"
                  >
                    <v-icon left>mdi-plus</v-icon>Create A Supplier
                  </v-btn>
                </v-row>
              </template> -->
            </v-autocomplete>

                <v-text-field
                  class="mt-2"
                  autocomplete="off"
                  type="text"
                  v-model="record.RefNo"
                  outlined
                  dense
                  label="Ref No"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="6">
            <v-row class="justify-end">
              <v-col cols="12" md="7">
                <span style="font-weight: bold; font-size: 18px; float: right">Debit Note#: {{ DocNum }}</span>
                <br />
                <br />
                <DatePicker
                  class="mt-2"
                  @date="setDate"
                  :myDate="date"
                  :title="`Date`"
                  ref="dateRef"
                ></DatePicker>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- end of first card -->

    <!-- no bp card -->
    <v-card class="mt-4">
      <v-card-text>
        <v-row dense id="po">
          <v-col cols="12">
            <v-data-table
              light
              dense
              :items-per-page="pageItems"
              :headers="headers"
              :items="orderItems"
              item-key="LineNum"
              hide-default-footer
              disable-sort
            >
              <template v-slot:item.Name="{ item }">
                <!-- autocomplete -->
                <v-text-field
                  style="width: 350px"
                  class="orderInput"
                  single-line
                  dense
                  readonly
                  v-model="item.Name"
                ></v-text-field>
              </template>

              <template v-slot:item.ref1="{ item }">
                <v-text-field
                  v-show="IMEI == 'Y'"
                  class="orderInput"
                  single-line
                  outlined
                  dense
                  v-model="item.ref1"
                ></v-text-field>
              </template>

              <template v-slot:item.available="{ item }">
                <div style="margin-right: ">{{ item.available }}</div>
              </template>

              <template v-slot:item.available="{ item }">
                <v-text-field single-line outlined dense readonly filled v-model="item.available"></v-text-field>
              </template>

              <template v-slot:item.Quantity="{ item }">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  class="orderInput"
                  @input="inputChanged(item)"
                  single-line
                  outlined
                  dense
                  v-model="item.Quantity"
                ></v-text-field>
              </template>

              <template v-slot:item.DiscSum="{ item }">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  class="orderInput"
                  @input="inputChanged(item)"
                  single-line
                  outlined
                  dense
                  v-model="item.DiscSum"
                ></v-text-field>
              </template>

              <template v-slot:item.Price="{ item }">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  class="orderInput"
                  @input="inputChanged(item)"
                  single-line
                  outlined
                  dense
                  v-model="item.Price"
                ></v-text-field>
              </template>

              <template v-slot:item.Margin="{ item }">
                <span style="color: red; margin: 5px">
                  {{
                  parseInt(
                  ((item.Price - item.BuyingPrice) / item.BuyingPrice) * 100
                  )
                  }}
                  %
                </span>
              </template>

              <template v-slot:item.TaxId="{ item }">
                <v-autocomplete
                  autocomplete="off"
                  dense
                  outlined
                  single-line
                  v-model="item.TaxId"
                  :items="taxGroups"
                  label="Tax"
                  item-text="Name"
                  item-value="id"
                  @change="inputChanged(item)"
                ></v-autocomplete>
              </template>

              <template v-slot:item.o_p_l_n_s_id="{ item }">
                <v-autocomplete
                  autocomplete="off"
                  dense
                  outlined
                  single-line
                  v-model="item.o_p_l_n_s_id"
                  :items="item.priceLists"
                  label="Price List"
                  item-text="pricelist.Name"
                  item-value="pricelist.id"
                  @change="oplnChange(item)"
                ></v-autocomplete>
              </template>

              <template v-slot:item.BuyingPrice="{ item }">
                <v-text-field filled outlined readonly dense v-model="item.BuyingPrice"></v-text-field>
              </template>

              <template v-slot:item.UomEntry="{ item }">
                <v-text-field
                  filled
                  outlined
                  readonly
                  dense
                  value="Unit(s)"
                  v-if="item.ManualStatus == 'Y'"
                ></v-text-field>

                <v-autocomplete
                  v-else
                  dense
                  autocomplete="off"
                  outlined
                  single-line
                  v-model="item.UomEntry"
                  :items="item.ugp1"
                  label="UOM"
                  item-text="UomName"
                  item-value="UomId"
                  @change="uomChange(item, item.ugp1)"
                ></v-autocomplete>
              </template>

              <template v-slot:item.LineTotal="{ item }">
                <v-text-field
                  class="orderInput"
                  single-line
                  outlined
                  dense
                  v-model="item.LineTotal"
                  @input="totalChanged(item)"
                ></v-text-field>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="deleteRow(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>

            <!-- <v-btn @click="addRow" small color="primary" class="mt-1">
              <v-icon left>mdi-plus</v-icon>Add Row
            </v-btn>-->

            <v-autocomplete
              style="width: 500px"
              autocomplete="off"
              v-model="select"
              :isloading="isLoading"
              :items="products"
              :search-input.sync="searchProducts"
              @change="setOrderItem(select)"
              :item-text="smsRef == 'pharmacy' ? 'full_name' : 'Name'"
              item-value="id"
              cache-items
              class="mt-2"
              flat
              hide-no-data
              hide-details
              label="Search Product"
              outlined
              dense
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{ smsRef == 'pharmacy' ? data.item.full_name : data.item.Name }}</v-list-item-title>
                  <v-list-item-subtitle
                    :v-html="`Available Qty: ${data.item.AvailableQty}`"
                  >Available Qty: {{ data.item.AvailableQty }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- end of card -->

    <!-- third card -->
    <v-row class="mt-2 mb-2">
      <v-col cols="12" md="8">
        <v-textarea outlined solo label="Notes / Terms" v-model="terms"></v-textarea>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-text>
            <v-row dense class="pa-1">
              <v-col cols="6" class="py-2 font-weight-medium" style="font-size: 1.2em;">Sub Total:</v-col>
              <v-col cols="6" class="py-2 font-weight-medium" style="font-size: 1.2em;">{{ totalAmount.toLocaleString() }}.00</v-col>

              <v-col cols="6" class="py-2 font-weight-light">
                <span style="font-weight: 600;">Tax:</span></v-col>
              <v-col cols="6" class="py-2">
                <span style="">{{ taxAmount.toLocaleString() }}.00</span>
                </v-col>

              <v-col cols="6" class="py-2 font-weight-bold" style="font-size: 1.4em;">Total Bill:</v-col>
              <v-col cols="6" class="py-2 font-weight-bold" style="font-size: 1.4em;">{{ (totalAmount + taxAmount).toLocaleString() }}.00</v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-divider class="mt-2"></v-divider>

    <v-row class="mt-2 mb-10">
      <v-col cols="12" md="12">
        <v-btn color="accent" class="float-right" @click="sendData" :loading="loader">
          <v-icon left>mdi-content-save</v-icon>Create Debit Note
        </v-btn>
      </v-col>
    </v-row>

    <!-- end of card -->

    <!-- Customer quick add dialog modal-->
    <v-dialog v-model="customerDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create A Customer</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="customerDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <customer-editor :initial="customerItem" @data="saveCustomer"></customer-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import CustomerEditor from "@/components/subscriber/customers/_components/quick-editor.vue";
export default {
  components: {
    CustomerEditor
  },
  props: {
    docCreate: {
      type: Boolean
    },
    loaderOff: {
      type: Boolean
    },
    copyStatus: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    terms: "",
    productRecord: {},
    productDialog: false,
    bpDialog: false,
    productItem: {},
    suppliers: [],
    bpProducts: [],
    printing: true,
    bpSetting: "",
    customerDialog: false,
    outsourcedDialog: false,
    currentCustomerBalance: null,
    select: "",
    selectDesc: "",
    searchProducts: null,
    searchCustomers: null,
    isLoading: false,
    outItem: {},
    accountItem: {},
    customerItem: {},
    bpText: "",
    accountDialog: false,
    enableCreate: true,
    searchingProduct: false,
    searchSuppliers: null,
    UserSign: null,
    enablePriceList: "N",
    showStockHint: true,
    ref2: null,
    IMEI: null,
    SlgPrcFixed: null,
    SoldBy: null,
    loader: false,
    pageItems: 100,
    DiscOnTotal: null,
    AmountGiven: null,
    multiplePayment: "Y",
    selectedProduct: null,
    SumApplied: null,
    DocNum: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    paymentItem: {},
    paymentDialog: false,
    payments: [],
    orderItems: [],
    customers: [],
    products: [],
    accounts: [],
    taxGroups: [],
    stores: [],
    users: [],
    outArray: [],
    drivers: [],
    date: new Date().toISOString().substr(0, 10),
    smsRef: "",
    clearDate: "",
    dateReadonly: "N",
    AccountVersion: "N",
    headers: [
      { text: "Product", value: "Name" },
      { text: "Qty To Sell", value: "Quantity" },
      { text: "Sales Unit", value: "UomEntry" },
      { text: "Selling Price", value: "Price" },
      { text: "Total", value: "LineTotal" },
      { text: "Action", value: "action" }
    ]
  }),
  computed: {
    userSign() {
      return localStorage.getItem("user_id");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    userName() {
      return localStorage.getItem("userName");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map(item => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    taxAmount() {
      var tax = 0;
      var totalTax = 0.16 * this.totalAmount;
      tax = totalTax;
      return tax;
    },
    totalAfterDisc() {
      let disc = 0;
      if (this.DiscOnTotal) {
        disc = this.DiscOnTotal;
      }
      const total = this.totalAmount + this.outTotalAmount - parseFloat(disc);
      return total;
    },
    totalAfterDiscDisplay() {
      return this.totalAfterDisc.toLocaleString();
    },
    totalDisplayAmount() {
      return this.totalAmount.toLocaleString();
    }
  },
  watch: {
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
    searchSuppliers(val) {
      if (val && val !== this.select && this.querySuppliers(val)) {
        this.querySuppliers(val);
      }
    }
  },
  methods: {
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      const data = {
        searchText: searchText
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData.length > 0) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    querySuppliers(searchText) {
      const self = this;
      const url = "/suppliers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    customerModal() {
      this.customerDialog = true;
    },
    saveCustomer(data) {
      const url = "/customers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            const customer = res.ResponseData;
            self.customers = [...this.customers, customer];
            self.record.CardCode = customer.id;
            self.$refs.snackbar.show("Customer Added Successully", "green");
            self.customerDialog = false;
            self.$store.commit("btnLoader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("btnLoader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          self.$store.commit("btnLoader", false);
        });
    },
    setDate(date) {
      this.date = date;
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
      this.activeRow = null;
      this.selectedItems = [];
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    totalChanged(data) {
      let Quantity;
      let LineTotal;

      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      if (data.LineTotal) {
        LineTotal = parseFloat(data.LineTotal);
      } else {
        LineTotal = 0;
      }

      const currentItem = this.orderItems.find(record => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }

      const correctPrice = LineTotal / Quantity;
      currentItem.Price = correctPrice;
      this.orderItems[pos] = currentItem;
    },
    inputChanged(data) {
      if (data.Quantity > data.available) {
        this.$refs.snackbar.show(
          `Your stock is low! current stock ${data.available}`,
          "red"
        );
      }

      let Price;
      let Quantity;
      let DiscSum;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      if (data.DiscSum) {
        DiscSum = parseFloat(data.DiscSum);
      } else {
        DiscSum = 0;
      }
      const TotalBefTax = Price * Quantity;
      // add tax
      const tax = this.taxGroups.find(record => {
        return record.id === data.TaxId;
      });
      let taxAmount = 0;
      let taxRate = 0;
      if (tax) {
        taxRate = tax.Rate;
        taxAmount = (taxRate / 100) * TotalBefTax;
      }
      const TotalAfterTax = TotalBefTax + taxAmount;
      const LineTotal = Math.round(TotalAfterTax - DiscSum);
      const DisplayTotal = LineTotal.toLocaleString();
      // find item
      const currentItem = this.orderItems.find(record => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find
      // update record
      currentItem.TaxRate = taxRate;
      currentItem.TaxAmount = taxAmount;
      currentItem.LineTotal = LineTotal;
      currentItem.DisplayTotal = DisplayTotal;
      this.orderItems[pos] = currentItem;
      // }
    },
    oplnChange(item) {
      const currentItem = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      const qData = {
        product_id: item.o_i_t_m_s_id,
        SUoMEntry: item.UomEntry,
        o_p_l_n_s_id: item.o_p_l_n_s_id
      };
      const url = "/price-calculation";
      const self = this;
      self.$store.dispatch("post", { url, data: qData }).then(res => {
        currentItem.Price = res.ResponseData.FINALSALESPRICE;
        self.orderItems[pos] = currentItem;
        self.inputChanged(currentItem);
      });
    },
    uomChange(item, ugp1) {
      const currentItem = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }

      const ugp1Record = ugp1.find(record => {
        return record.UomEntry === item.UomEntry;
      });

      currentItem.Price = ugp1Record.SellingPrice;
      currentItem.BuyingPrice = ugp1Record.BuyingPrice;
      this.orderItems[pos] = currentItem;
      this.inputChanged(currentItem);
    },
    setOrderItem(id) {
      const store_id = this.activeStore;
      const self = this;
      // fetch the product from database
      this.$store
        .dispatch("get", `/products/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;

            // current item definition
            let currentItem = {};
            currentItem.Quantity = null;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.UomEntry = product.SUoMEntry;
            currentItem.o_i_t_m_s_id = id;
            currentItem.Name = product.Name;
            currentItem.store_id = store_id;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            // end

            let initArray = [];
            if (product.HasUom === 0) {
              // check if manual yes and assign
              var sellingPrice = product.sellingPrice;
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.Price = sellingPrice;
              currentItem.currentPrice = sellingPrice;
              const total = 0;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = 0;

              initArray.push(currentItem);
              this.orderItems = [...this.orderItems, ...initArray];
              this.select = null;
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.SUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.Price = ugp1Record.SellingPrice;
              currentItem.currentPrice = ugp1Record.SellingPrice;
              const total = 0;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = 0;

              // push to array
              initArray.push(currentItem);
              this.orderItems = [...this.orderItems, ...initArray];
              this.select = "";
              self.products = [];
              // end of push
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    sendData() {
      if (this.date == null || this.date == undefined) {
        this.$refs.snackbar.show("Please select date!", "red");
        return;
      }

      if (this.orderItems.length <= 0 && this.outArray.length <= 0) {
        this.$refs.snackbar.show("You must have at least one product", "red");
        return;
      }

      let saleDate = this.date;
      this.record = { ...this.record, DocDate: saleDate };
      const data = this.record;
      data.ObjType = 11;
      data.DocTotal = this.totalAmount;
      data.DocNum = this.DocNum;
      data.CreatedBy = this.UserSign;
      data.ref2 = this.ref2;
      var storeId = parseInt(this.activeStore);
      data.storeId = storeId;
      data.CreatedBy = parseInt(this.userSign);
      data.terms = this.terms;

      // append order rows
      var orderData = this.orderItems;

      var rows = [];
      for (const row of orderData) {
        var details = {
          productId: row.o_i_t_m_s_id,
          UomEntry: row.UomEntry,
          Quantity: parseFloat(row.Quantity),
          Price: parseFloat(row.Price),
          LineTotal: parseFloat(row.LineTotal),
          name: row.Name,
          storeId: storeId
        };

        rows.push(details);
      }
      // end
        
      data.rows = rows;

      // save data
      const url = "/purchases/return";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.getDocNum();
            const NewDate = this.record.DocDate;
            self.record = {};
            self.record.DocDate = NewDate;
            if (self.clearDate == "Y") {
              this.$refs.dateRef.clearDate();
            }
            self.orderItems = [];
            self.SumApplied = 0;
            self.DiscOnTotal = 0;
            self.ref2 = null;
            self.UserSign = null;
            this.$refs.snackbar.show("Created successful", "green");
            this.loader = false;
          } else {
            this.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/11`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.DocNum = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    addRow() {
      let initArray = [];
      const LineNum = `${new Date().getTime()}-${Math.random()}`;
      const details = {
        LineNum: LineNum,
        Name: null,
        Quantity: 1,
        Price: null,
        LineTotal: 0,
        TaxId: this.taxGroups[0].id,
        TaxRate: null,
        ref1: null,
        TaxAmount: null,
        UomEntry: null,
        ManualStatus: null,
        ugp1: [],
        DiscSum: null,
        DisplayTotal: 0,
        BatchID: null,
        PurchaseCurrency: null,
        cnvRate: null,
        BaseCurrencyTotal: null
      };
      initArray.push(details);
      this.orderItems = [...this.orderItems, ...initArray];
    },
    getCustomerBalance(id) {
      const self = this;
      this.$store
        .dispatch("get", `/get-customer-balance/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.currentCustomerBalance = res.ResponseData.Balance;
          } else {
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    resetLoader() {
      this.loader = false;
      this.$store.commit("btnLoader", false);
    }
  },
  created() {
    // this.setDefaultRow();
    Promise.all([
      this.getDocNum()
    ]);
  }
};
</script>

<style lang="scss" scoped>
.genFont {
  font-size: 1.3em;
  font-weight: 500;
}
</style>